import React, { useState } from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Divider,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from '@mui/material';

const Footer = () => {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    resellerId: '',
    email: '',
    request: '',
  });

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async () => {
    try {
      const res = await fetch('https://reviewhub-lc.onrender.com/api/request', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const data = await res.json();

      if (res.ok) {
        alert('Request submitted successfully');
        setFormData({ resellerId: '', email: '', request: '' });
        handleClose();
      } else {
        alert('Error: ' + data.message);
      }
    } catch (err) {
      alert('Server error');
      console.error(err);
    }
  };

  return (
    <Box sx={{ backgroundColor: '#000', color: '#fff', pt: 6, pb: 4 }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Brand Info */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Product Review Hub
            </Typography>
            <Typography variant="body2" sx={{ color: 'gray.400', lineHeight: 1.7 }}>
              Your trusted platform for genuine product reviews, empowering shoppers with honest feedback and verified experiences.
            </Typography>
          </Grid>

          {/* Contact + Request Button */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Contact Us
            </Typography>
            <Typography variant="body2" sx={{ color: 'gray.300' }}>Email: support@productreviewhub.com</Typography>
            <Typography variant="body2" sx={{ color: 'gray.300', mb: 2 }}>Phone: +91 98765 43210</Typography>
            <Button
              variant="outlined"
              onClick={handleOpen}
              size="small"
              sx={{
                color: '#fff',
                borderColor: '#fff',
                '&:hover': {
                  backgroundColor: '#fff',
                  color: '#000',
                },
              }}
            >
              Send Request
            </Button>
          </Grid>

          {/* Quick Links (Optional) */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Quick Links
            </Typography>
            <Typography variant="body2" sx={{ color: 'gray.300', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}>
              About Us
            </Typography>
            <Typography variant="body2" sx={{ color: 'gray.300', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}>
              Privacy Policy
            </Typography>
            <Typography variant="body2" sx={{ color: 'gray.300', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}>
              Terms of Service
            </Typography>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, borderColor: 'rgba(255,255,255,0.1)' }} />

        <Typography variant="body2" align="center" sx={{ opacity: 0.5 }}>
          © {new Date().getFullYear()} Product Review Hub. All rights reserved.
        </Typography>
      </Container>

      {/* Request Dialog */}
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle sx={{ fontWeight: 'bold' }}>Send a Request</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Reseller ID"
            name="resellerId"
            fullWidth
            variant="outlined"
            value={formData.resellerId}
            onChange={handleChange}
          />
          <TextField
            margin="dense"
            label="Email"
            name="email"
            fullWidth
            variant="outlined"
            value={formData.email}
            onChange={handleChange}
          />
          <TextField
            margin="dense"
            label="Request Message"
            name="request"
            fullWidth
            multiline
            rows={4}
            variant="outlined"
            value={formData.request}
            onChange={handleChange}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} sx={{ color: '#555' }}>
            Cancel
          </Button>
          <Button onClick={handleSubmit} variant="contained" sx={{ backgroundColor: '#EC407A' }}>
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Footer;
